import React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="add circle active-layer"
    viewBox="0 0 18 18"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M7.66 2.34a.79.79 0 0 1 .57.23l2.57 2.58V6.8l.82.27 5 1.66a.3.3 0 0 1 .18.27v6a1.8 1.8 0 0 1-1.8 1.8h-3.34a2.78 2.78 0 0 1-2-.82L6 12.29a.8.8 0 0 1 1.13-1.13l2 2V5.81l-.35-.35L7.09 3.7a.8.8 0 0 1 .57-1.37m0-1.2a2 2 0 0 0-1.41.59 2 2 0 0 0 0 2.83L8 6.31v4a2 2 0 0 0-2.83 0 2 2 0 0 0 0 2.83l3.66 3.66a4 4 0 0 0 2.83 1.2H15a3 3 0 0 0 3-3V9a1.5 1.5 0 0 0-1-1.42L12 6V4.65L9.07 1.72a2 2 0 0 0-1.41-.59z" />
    <path d="M5 7.57L3 9.53V2.33l2 1.95V2.54L2.49.03 0 2.52v1.76l2-1.95V9.53L0 7.57V9.3l2.51 2.52L5 9.32V7.57z" />
  </svg>
);

export default SvgComponent;
